// src/ErrorBoundary.js
import React from 'react';
import { StyledErrorContainer, StyledErrorPre } from './styles/errorBoundaryStyles';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <StyledErrorContainer>
          <h1>Something went wrong.</h1>
          <p>An unexpected error has occurred. Please try refreshing the page.</p>
          {this.state.error && (
            <StyledErrorPre>
              {this.state.error.toString()}
            </StyledErrorPre>
          )}
        </StyledErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
